import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './shared/navbar/navbar.component';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule, NavbarComponent],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  faqs = [
    {
      question: 'What makes AARVYA different from other herbal brands?',
      answer: 'AARVYA focuses on ingredient purity, responsible sourcing, and recognized quality standards rather than exaggerated marketing claims. Our philosophy is simple: No Magic Claims. Just Pure Ingredients. Consistent Quality.',
      isOpen: true
    },
    {
      question: 'How does AARVYA ensure product quality?',
      answer: 'Our ingredients are sourced from trusted farms and processed in facilities that follow strict hygiene and quality standards to preserve the natural nutrients and purity of herbs.',
      isOpen: false
    },
    {
      question: 'Where are AARVYA herbs sourced from?',
      answer: 'We work with trusted sourcing partners and farms that follow responsible agricultural practices so the herbs maintain their natural potency and quality.',
      isOpen: false
    },
    {
      question: 'Are AARVYA products safe for daily use?',
      answer: 'AARVYA products are made from natural herbal ingredients traditionally used in Ayurvedic wellness practices. People with medical conditions or those who are pregnant, nursing, or taking medication should consult a healthcare professional before use.',
      isOpen: false
    },
    {
      question: 'Do AARVYA products contain additives or preservatives?',
      answer: 'Our focus is on clean and simple ingredient profiles. We aim to avoid unnecessary additives or preservatives while maintaining product quality and freshness.',
      isOpen: false
    },
    {
      question: 'How should herbal powders be consumed?',
      answer: 'Usage instructions are provided on the product packaging. Typically herbal powders can be mixed with water, milk, smoothies, or food preparations depending on the product.',
      isOpen: false
    },
    {
      question: 'How long does delivery take?',
      answer: 'Orders are usually processed within 1–3 business days. Delivery timelines typically range from 3–5 business days for metro cities and 5–8 business days for other locations.',
      isOpen: false
    },
    {
      question: 'What should I do if I receive a damaged product?',
      answer: 'If you receive a damaged or incorrect product, please contact our support team within 48 hours of delivery with your order details and photos so we can assist you.',
      isOpen: false
    },
    {
      question: 'Are AARVYA products medicines?',
      answer: 'No. AARVYA products are natural wellness products and not pharmaceutical medicines. They are not intended to diagnose, treat, cure, or prevent any disease.',
      isOpen: false
    },
    {
      question: 'Why do customers trust AARVYA?',
      answer: 'Customers trust AARVYA because we focus on purity, responsible sourcing, transparent practices, and consistent product quality.',
      isOpen: false
    }
  ];

  toggleFaq(index: number) {
    this.faqs[index].isOpen = !this.faqs[index].isOpen;
  }
}
